import { render, staticRenderFns } from "./incourse_marks_entry_form_admin.vue?vue&type=template&id=8b3f971e&"
import script from "./incourse_marks_entry_form_admin.vue?vue&type=script&lang=js&"
export * from "./incourse_marks_entry_form_admin.vue?vue&type=script&lang=js&"
import style0 from "./incourse_marks_entry_form_admin.vue?vue&type=style&index=0&id=8b3f971e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports